import { EXERCISE_LIST } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case EXERCISE_LIST.LOAD:
      return {
        ...state,
        loading: true
      };
    case EXERCISE_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case EXERCISE_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
